import { useMutation } from 'react-query';
import { employeeApi } from '../../api';

const useDelete = () => {
  const mutation = useMutation((id: number): any => {
    return employeeApi.delete(id);
  });
  return mutation;
};

export default useDelete;
